import React from "react";
import RenderOneBarcode from "./components/RenderOneBarcode";
import MultipleGeneratorLayout from "./components/common/MultipleGeneratorLayout";

const STORAGE_KEY = "barcodeData";
const DEFAULT_DATA = ["Phong", "Peter", "", ""];
const MAX_ITEMS = 40;

const BarcodeGenerator: React.FC = () => {
  return (
    <MultipleGeneratorLayout
      storageKey={STORAGE_KEY}
      defaultData={DEFAULT_DATA}
      maxItems={MAX_ITEMS}
      itemName="Barcode"
      confirmClearMessage="Are you sure you want to clear all Barcodes?"
      RenderComponent={RenderOneBarcode as any}
    />
  );
};

export default BarcodeGenerator;